import React, { useEffect, useState } from "react";


const leadershipModulesData = [

  {
    stage: "Semester 1: Foundation",
    title: "Foundation",
    duration: "N/A",
    modules: [
      {
        title: "Global Strategic Management",
        credits: 6,
        description:
          "The module helps you develop skills to create and implement business strategies for competitive global markets.",
      },
      {
        title: "Organisational Leadership",
        credits: 6,
        description:
          "This course teaches you about advanced leadership models and how to lead diverse teams while achieving organizational effectiveness.",
      },
      {
        title: "Business Ethics & Corporate Governance",
        credits: 6,
        description:
          "This course teaches you about ethical frameworks and sustainability practices and governance structures that exist in global business environments.",
      },
      {
        title: "Innovation and Entrepreneurship",
        credits: 6,
        description:
          "The module teaches students to detect innovative opportunities while creating business solutions for intricate business problems.",
      },
      {
        title: "Communication, Influence & Negotiation for Leaders",
        credits: 6,
        description:
          "The module teaches essential executive-level leadership skills through persuasive communication and influence and negotiation techniques.",
      },
    ],
  },

  {
    stage: "Semester 2: Strategic Development",
    title: "Strategic Development",
    duration: "N/A",
    modules: [
      {
        title: "Strategic Marketing in Global Contexts",
        credits: 6,
        description:
          "Learn to develop marketing campaigns for various international markets and cultural environments through this course.",
      },
      {
        title: "Financial Decision-Making in Global Business",
        credits: 6,
        description:
          "Learn fundamental financial tools and analytical frameworks to support global investment and budgetary decision processes.",
      },
      {
        title: "Strategic Human Capital & Talent Management",
        credits: 6,
        description:
          "Learn how to build successful plans for recruiting and developing and keeping top performers in demanding worldwide markets.",
      },
      {
        title: "Leading Change & Organisational Development",
        credits: 6,
        description:
          "Lead transformation efforts, manage resistance, and implement sustainable organisational change strategies.",
      },
      {
        title: "Research Methods for Strategic Leaders ",
        credits: 6,
        description:
          "Acquire research design and data analysis competencies to solve strategic business problems.",
      },
    ],
  },

  {
    stage: "Semester 3: Capstone & Dissertation",
    title: "Capstone & Dissertation",
    duration: "N/A",
    modules: [
      {
        title: "International Business & Global Strategy",
        credits: 6,
        description:
          "The course teaches students to analyse globalization and market entry methods and cross-border strategic frameworks for international organization leadership.",
      },
      {
        title: "Professional Consulting in Practice",
        credits: 6,
        description:
          "The course teaches students how to apply consultancy methods and project scoping and client management approaches in real-world situations.",
      },
      {
        title: "Strategic Risk Management & Crisis Leadership",
        credits: 6,
        description:
          "The course teaches students to predict risks while leading under stress and handling crises through resilient and controlled responses.",
      },
      {
        title: "Master’s Thesis",
        credits: 12,
        description:
          "You will complete an independent research project that explores a strategic leadership topic of your selection.",
      },
    ],
  },
];


const LeadershipModules = () => {

  const [activeStages] = useState(leadershipModulesData.map((_, i) => i));

  const [isMobile, setIsMobile] = useState(false);
  const [openModuleIndex, setOpenModuleIndex] = useState({});

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleModuleDetails = (stageIndex, modIndex) => {
    setOpenModuleIndex((prev) => ({
      ...prev,
      [stageIndex]: prev[stageIndex] === modIndex ? null : modIndex,
    }));
  };

  return (
    <div className="md:scroll-mt-44 scroll-mt-16" id="modules">
      <div className="max-w-6xl mx-auto p-2 md:px-10 flex justify-center flex-col items-center md:mt-3">
        <h2 className="text-center text-2xl font-bold pb-4 border-b-4 border-sdorange inline-block mx-auto mb-2">
          Programme Modules
        </h2>

        <div
          className={`${
            isMobile ? "space-y-6" : "flex space-x-6 overflow-x-auto"
          }`}
        >
          {activeStages.map((stageIndex) => {
            const { title, modules } = leadershipModulesData[stageIndex];
            const totalECTS = modules.reduce((sum, m) => sum + m.credits, 0);
            const moduleCount = modules.length;

            return (
              <div
                key={stageIndex}
                id={`stage-${stageIndex}`}
                className="md:max-w-[350px] scroll-mt-44 border-2 rounded-md bg-gray-400 bg-opacity-50 border-sdorange p-2"
              >
                <h3 className="text-xl font-semibold mb-2">{title}</h3>
                <p>{moduleCount} Compulsory Modules</p>
                <div className="flex items-center space-x-3 mb-3 bg-sdorange/80">
                  <div className="bg-black w-[2px] h-6" />
                  <p>{totalECTS} ECTS</p>
                </div>

                {modules.map((mod, modIndex) => {
                  const isOpen = openModuleIndex[stageIndex] === modIndex;
                  return (
                    <div key={modIndex} className="mb-4">
                      <button
                        onClick={() =>
                          toggleModuleDetails(stageIndex, modIndex)
                        }
                        className="flex justify-between items-center w-full px-2 py-1 space-x-2 bg-sdorange rounded text-gray-700"
                      >
                        <div className="flex items-center space-x-2">
                          <img
                            src="/image-fix/academic-programmes/certified-courses/icons/play-circle-svgrepo-com.svg"
                            alt="Play Icon"
                            className="h-4 w-4"
                          />
                          <p className="font-semibold text-sm text-left">
                            {mod.title}
                          </p>
                        </div>

                        <span className="flex items-center space-x-1">
                          <p className="text-sm items-center border border-sdorange text-sdorange bg-sddarkgray px-2 rounded-md max-w-14">
                            {mod.credits} ECTS
                          </p>
                          {isOpen ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 15l7-7 7 7"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          )}
                        </span>
                      </button>

                      {isOpen && (
                        <div className="mt-2 p-2 bg-sdbodywhite rounded shadow text-sm text-gray-700">
                          {mod.subModules ? (
                            <div className="space-y-4">
                              <p>{mod.description}</p>
                              {mod.subModules.map((sub, i) => (
                                <div
                                  key={i}
                                  className="ml-3 border-l-2 border-gray-300 pl-3"
                                >
                                  <p className="font-medium">{sub.title}</p>
                                  <p>{sub.description}</p>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p>{mod.description}</p>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LeadershipModules;
